import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TableContainer,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  Button,
  Modal,
  InlineLoading,
  TextInput,
  TextArea,
  Select,
  SelectItem,
  OverflowMenu,
  OverflowMenuItem,
} from "@carbon/react";
import { callApi } from "../../../services/apiService";
import { Add } from "@carbon/icons-react";

export default function SubscriptionOffers() {
  const location = useLocation();

  const subscription = location.state?.subscription;
  console.log(subscription);
  const headers = [
  { key: "offerName", header: "Offer Name" },
  { key: "offerCode", header: "Offer Code" },
  { key: "discount", header: "Discount" },
  { key: "status", header: "Status" },
  { key: "startDate", header: "Start Date" },
  { key: "endDate",header: "End Date"},
  { key: "actions", header: "Actions" }
];
const [offers, setOffers] = useState(subscription?.offers || []);
console.log("offers", offers);

const [searchTerm, setSearchTerm] = useState("");
const allRows = (offers || [])
  .filter((offer) => offer && offer.id)
  .map((offer) => ({
    id: String(offer.id),
    offerName: offer.offerName,
    offerCode: offer.offerCode,
    discount:
      offer.discountType === "PERCENTAGE"
        ? `${offer.discountValue}%`
        : `₹${offer.discountValue}`,
    status: offer.isActive ? "Active" : "Inactive",
    startDate: new Date(offer.offerStartAt).toLocaleDateString(
      "en-GB",
      {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }
    ),
    endDate: new Date(offer.offerEndAt).toLocaleDateString(
  "en-GB",
  {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }
),
    actions: "",
    offer,
  }));

const rows = allRows.filter((row) =>
  row.offerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  row.offerCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
  row.discount.toLowerCase().includes(searchTerm.toLowerCase()) ||
  row.status.toLowerCase().includes(searchTerm.toLowerCase())
);
  const [isModalOpen, setIsModalOpen] = useState(false);
const [isEdit, setIsEdit] = useState(false);
const [editingOffer, setEditingOffer] = useState(null);

const [formData, setFormData] = useState({
  offerName: "",
  offerCode: "",
  offerDescription: "",
  discountType: "PERCENTAGE",
  discountValue: "",
  offerStartAt: "",
  offerEndAt: "",
  offerBadge: "",
  offerColor: "#FFD700",
  priority: 1,
  isNewUsersOnly: 0,
  termsAndConditions: "",
  isActive: 1,
});
const [offerToDelete, setOfferToDelete] = useState(null);
const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
const [deleting, setDeleting] = useState(false);
const handleAddOffer = () => {
  setIsEdit(false);
  setEditingOffer(null);

  setFormData({
    offerName: "",
    offerCode: "",
    offerDescription: "",
    discountType: "PERCENTAGE",
    discountValue: "",
    offerStartAt: "",
    offerEndAt: "",
    offerBadge: "",
    offerColor: "#FFD700",
    priority: 1,
    isNewUsersOnly: 0,
    termsAndConditions: "",
    isActive: 1,
  });

  setIsModalOpen(true);
};
const handleEditOffer = (row) => {
  const offer = offers.find(
    (item) => String(item.id) === String(row.id)
  );

  if (!offer) {
    console.log("Offer not found");
    return;
  }

  setIsEdit(true);
  setEditingOffer(offer);

  setFormData({
    offerName: offer.offerName,
    offerCode: offer.offerCode,
    offerDescription: offer.offerDescription,
    discountType: offer.discountType,
    discountValue: offer.discountValue,
    offerStartAt: offer.offerStartAt.replace(" ", "T").slice(0, 16),
    offerEndAt: offer.offerEndAt.replace(" ", "T").slice(0, 16),
    offerBadge: offer.offerBadge,
    offerColor: offer.offerColor,
    priority: offer.priority,
    isNewUsersOnly: offer.isNewUsersOnly,
    termsAndConditions: offer.termsAndConditions,
    isActive: offer.isActive,
  });

  setIsModalOpen(true);
};
const handleDeleteOffer = (row) => {
  const offer = offers.find(
    (item) => String(item.id) === String(row.id)
  );

  if (!offer) return;

  setOfferToDelete(offer);
  setIsDeleteModalOpen(true);
};
const handleConfirmDelete = async () => {
  if (!offerToDelete) return;

  setDeleting(true);

  try {
    await callApi(
      "DELETE",
      `/subscription-plan-offers/${offerToDelete.id}`
    );

    setOffers((prev) =>
      prev.filter(
        (offer) => offer.id !== offerToDelete.id
      )
    );

    setIsDeleteModalOpen(false);
    setOfferToDelete(null);

  } catch (err) {
    console.log(err);
  } finally {
    setDeleting(false);
  }
};
const handleUpdateOffer = async () => {
  try {
    const form = new FormData();

    form.append("offer_name", formData.offerName);
    form.append("offer_code", formData.offerCode);
    form.append("offer_description", formData.offerDescription);
    form.append("discount_type", formData.discountType);
    form.append("discount_value", formData.discountValue);
    form.append(
      "offer_start_at",
      formData.offerStartAt + ":00"
    );
    form.append(
      "offer_end_at",
      formData.offerEndAt + ":00"
    );
    form.append("is_active", formData.isActive);
    form.append("offer_badge", formData.offerBadge);
    form.append("offer_color", formData.offerColor);
    form.append("priority", formData.priority);
    form.append(
      "is_new_users_only",
      formData.isNewUsersOnly
    );
    form.append(
      "terms_and_conditions",
      formData.termsAndConditions
    );

    const response = await callApi(
  "PUT",
  `/subscription-plan-offers/${editingOffer.id}`,
  form
);
console.log("PUT Response:", response);

const updatedOffer = response.data;

if (!updatedOffer) {
  console.log("Updated offer missing", response);
  return;
}

setOffers((prev) =>
  prev.map((offer) =>
    offer && offer.id === updatedOffer.id
      ? updatedOffer
      : offer
  )
);

setIsModalOpen(false);

  } catch (err) {
    console.log(err);
  }
};
const handleCreateOffer = async () => {
  try {
    const form = new FormData();

    form.append("subscription_plan_id", subscription.planId);
    form.append("offer_name", formData.offerName);
    form.append("offer_code", formData.offerCode);
    form.append("offer_description", formData.offerDescription);
    form.append("discount_type", formData.discountType);
    form.append("discount_value", formData.discountValue);
    form.append(
      "offer_start_at",
      formData.offerStartAt + ":00"
    );
    form.append(
      "offer_end_at",
      formData.offerEndAt + ":00"
    );
    form.append("is_active", formData.isActive);
    form.append("offer_badge", formData.offerBadge);
    form.append("offer_color", formData.offerColor);
    form.append("priority", formData.priority);
    form.append(
      "is_new_users_only",
      formData.isNewUsersOnly
    );
    form.append(
      "terms_and_conditions",
      formData.termsAndConditions
    );

    // later
    // form.append("image_file", selectedImage);

    const response = await callApi(
  "POST",
  "/subscription-plan-offers/",
  form
);

console.log("POST Response:", response);

const createdOffer = response.data;

console.log("createdOffer", createdOffer);
console.log("prev offers", offers);

setOffers((prev) => {
  console.log("prev", prev);
  console.log("adding", createdOffer);

  return [...prev, createdOffer];
});

setIsModalOpen(false);

  } catch (err) {
    console.log(err);
  }
};
  


  return (
    <div
  style={{
    padding: "1.5rem",
    maxWidth: "100%",
    margin: "0 auto",
  }}
>
      <h2
  style={{
    fontSize: "32px",
    fontWeight: 400,
    marginBottom: "16px",
  }}
>
  Subscription Offers
</h2>

<h3
  style={{
    fontSize: "18px",
fontWeight: 400,
marginBottom: "24px",
  }}
>
  {subscription?.planName}
</h3>


<DataTable rows={rows} headers={headers}>
  {({ rows, headers, getTableProps, getHeaderProps, getRowProps }) => (
<TableContainer title="">

<TableToolbar>
  <TableToolbarContent>

    <TableToolbarSearch

      persistent
      id="offer-search"
      placeholder="Search offers..."
      onChange={(e) => setSearchTerm(e.target.value)}
    />

  
<Button
    renderIcon={Add}
    onClick={handleAddOffer}
>
    Add Offer
</Button>

  </TableToolbarContent>
</TableToolbar>

  <Table>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <TableHeader
          key={header.key}
                {...getHeaderProps({ header })}
              >
                {header.header}
              </TableHeader>
            ))}
          </TableRow>
        </TableHead>

<TableBody>
  {rows.length > 0 ? (
    rows.map((row) => (
      <TableRow key={row.id} {...getRowProps({ row })}>
        {row.cells.map((cell) => (
          <TableCell key={cell.id}>
            {cell.info.header === "actions" ? (
              <OverflowMenu flipped>
                <OverflowMenuItem
                  itemText="Edit"
                  onClick={() => handleEditOffer(row)}
                />

                <OverflowMenuItem
                  isDelete
                  itemText="Delete"
                  onClick={() => handleDeleteOffer(row)}
                />
              </OverflowMenu>
            ) : (
              cell.value
            )}
          </TableCell>
        ))}
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell
        colSpan={headers.length}
        style={{
          textAlign: "center",
          padding: "80px 0",
          color: "#6f6f6f",
          fontSize: "16px",
          fontWeight: "500",
        }}
      >
        No offers available
      </TableCell>
    </TableRow>
  )}
</TableBody>
      </Table>
    </TableContainer>
  )}
</DataTable>

<Modal
  open={isModalOpen}
  modalHeading={isEdit ? "Edit Offer" : "Add Offer"}
  primaryButtonText={isEdit ? "Update" : "Save"}
  secondaryButtonText="Cancel"
  onRequestClose={() => setIsModalOpen(false)}
onRequestSubmit={() => {
  if (isEdit) {
    handleUpdateOffer();
  } else {
    handleCreateOffer();
  }
}}
>
  <TextInput
    id="offerName"
    labelText="Offer Name"
    value={formData.offerName}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerName: e.target.value,
      })
    }
  />

  <TextInput
    id="offerCode"
    labelText="Offer Code"
    value={formData.offerCode}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerCode: e.target.value,
      })
    }
  />

  <TextArea
    id="offerDescription"
    labelText="Description"
    value={formData.offerDescription}
    onChange={(e) =>
      setFormData({
        ...formData,
        offerDescription: e.target.value,
      })
    }
  />
  <TextInput
  id="discountValue"
  labelText="Discount Value"
  value={formData.discountValue}
  onChange={(e) =>
    setFormData({
      ...formData,
      discountValue: e.target.value,
    })
  }
/>

<Select
  id="discountType"
  labelText="Discount Type"
  value={formData.discountType}
  onChange={(e) =>
    setFormData({
      ...formData,
      discountType: e.target.value,
    })
  }
>
  <SelectItem value="PERCENTAGE" text="Percentage" />
  <SelectItem value="FIXED" text="Fixed" />
</Select>

<TextInput
  id="offerBadge"
  labelText="Offer Badge"
  value={formData.offerBadge}
  onChange={(e) =>
    setFormData({
      ...formData,
      offerBadge: e.target.value,
    })
  }
/>

<TextInput
  id="offerStartAt"
  labelText="Start Date"
  type="datetime-local"
  value={formData.offerStartAt}
  onChange={(e) =>
    setFormData({
      ...formData,
      offerStartAt: e.target.value,
    })
  }
/>

<TextInput
  id="offerEndAt"
  labelText="End Date"
  type="datetime-local"
  value={formData.offerEndAt}
  onChange={(e) =>
    setFormData({
      ...formData,
      offerEndAt: e.target.value,
    })
  }
/>
</Modal>

<Modal
  open={isDeleteModalOpen}
  modalHeading="Confirm Delete"
  primaryButtonText={
    deleting ? (
      <InlineLoading description="Deleting..." />
    ) : (
      "Delete"
    )
  }
  secondaryButtonText="Cancel"
  danger
  onRequestClose={() => {
    if (!deleting) {
      setIsDeleteModalOpen(false);
      setOfferToDelete(null);
    }
  }}
  onRequestSubmit={handleConfirmDelete}
>
  <p>
    Are you sure you want to delete the offer{" "}
    <strong>{offerToDelete?.offerName}</strong>?
  </p>

  <p style={{ marginTop: "1rem" }}>
    This action cannot be undone.
  </p>
</Modal>

</div>

);
}